import { render } from "./SkeletonRow.vue?vue&type=template&id=6b8471bd&scoped=true&ts=true"
import script from "./SkeletonRow.vue?vue&type=script&lang=ts"
export * from "./SkeletonRow.vue?vue&type=script&lang=ts"

import "./SkeletonRow.vue?vue&type=style&index=0&id=6b8471bd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8471bd"]])

export default __exports__